module.exports = __webpack_public_path__ + "img/home_pic_yysq.f37a487f.png";